import useQreId from './useQreId';

const suffixToUrl: Record<string, string> = {
  T: 'scriptingtool.commity.cz',
  CZ: 'cz.qrebuilder.com',
  AT: 'at.qrebuilder.com',
  HU: 'hu.qrebuilder.com',
  S: 'sandbox.qrebuilder.com',
  E2E: 'e2e-nfield.qrebuilder.commity.cz',
};

const useQreIdData = () => {
  const { qreId } = useQreId();
  const [projectIdAsString, surveyIdAsString, suffix] = qreId.split('_');

  const projectId = Number(projectIdAsString);
  const surveyId = Number(surveyIdAsString);
  const url = suffixToUrl[suffix];

  return { qreId, projectId, surveyId, url };
};

export default useQreIdData;
